// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5002';

export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login',
  PROFILE: '/api/auth/profile',
  CHANGE_PASSWORD: '/api/auth/change-password',
  
  // Bookings
  BOOKINGS: '/api/bookings',
  BOOKING_STATS: '/api/bookings/stats',
  
  // Tickets
  TICKETS: '/api/tickets',
  VALIDATE_TICKET: '/api/tickets/validate',
  USE_TICKET: '/api/tickets/use',
  
  // Settings
  SETTINGS: '/api/settings',
  
  // Payments
  PAYMENTS: '/api/payments',
  PAYMENT_WEBHOOK: '/api/payments/webhook',
  
  // Email
  EMAIL_SETTINGS: '/api/email/settings',
  EMAIL_TOGGLE: '/api/email/settings/toggle',
  EMAIL_CONTENT: '/api/email/settings/content',
  EMAIL_TEST_TEMPLATE: '/api/email/test-template',
  
  // Config
  CONFIG: '/api/config',
  
  // Invoices
  INVOICES: '/api/invoices',
  INVOICE_SETTINGS: '/api/invoices/settings',
  
  // Cities
  CITIES: '/api/cities',
  
  // Promo Codes
  PROMO_CODES: '/api/promo-codes',
  PROMO_CODES_ADMIN_ALL: '/api/promo-codes/admin/all',
  PROMO_CODES_ADMIN_CREATE: '/api/promo-codes/admin/create',
  PROMO_CODES_ADMIN_UPDATE: '/api/promo-codes/admin/update',
  PROMO_CODES_ADMIN_DELETE: '/api/promo-codes/admin/delete',
  PROMO_CODES_ADMIN_TOGGLE: '/api/promo-codes/admin/toggle'
};